import tv, { SchemaType } from "typed-object-validator";
import { MultipleAnswerValue, MultipleTableAnswerValue, NumberAnswerValue, OpenAnswerValue } from "./Answer";
import { Question, Questionnaire, QuestionType } from "./Questionnaire";

export function checkMultipleAnswer(answer: MultipleAnswerValue, condition: MultipleConditionValue): [boolean, string] {
    if (!condition.orOptions) return [true, "Geen conditie opties zijn gegeven."];
    let res;
    if (answer.other) {
        res = condition.orOptions.some((e) => Condition.compare(answer.other!, e));
        if (res) return [true, "Anders veld voldoet aan de criteria."];
    }
    res = condition.orOptions.some((e) => answer.selected.some((b) => Condition.compare(e, b)));
    return [res, res ? "Antwoord voldoet aan criteria" : "Antwoord niet gevonden in criteria-lijst."];
}

export function checkOpenAnswer(answer: OpenAnswerValue, condition: OpenConditionValue): [boolean, string] {
    let res = answer.value.includes(condition.contains);
    return [res, res ? "Antwoord bevat de criteria-termen." : "Antwoord ontbreekt criteria-termen."];
}

export function checkNumberAnswer(answer: NumberAnswerValue, condition: NumberConditionValue): [boolean, string] {
    switch (condition.operator) {
        case "min":
            if (answer.value < condition.min) return [false, "Antwoord is kleiner dan het minimum."];
            break;
        case "max":
            if (answer.value > condition.max) return [false, "Antwoord is groter dan het maximum."];
            break;
    }
    return [true, "Antwoord is binnen criteria-bereik."];
}

export function checkMultipleTableAnswer(answer: MultipleTableAnswerValue, condition: MultipleTableConditionValue): [boolean, string] {
    return [false, "Niet ondersteund."];
}

export const checkers: Record<QuestionType, (answerValue: any, conditionValue: any) => [boolean, string]> = {
    open: checkOpenAnswer,
    multiple: checkMultipleAnswer,
    multipletable: checkMultipleTableAnswer,
    number: checkNumberAnswer,
    ensure: () => [false, "Not supported"],
    location: () => [false, "Not supported"],
    title: () => [false, "Not supported"],
    image: () => [false, "Not supported"],
};

export const PartialConditionSchema = tv.object({
    id: tv.number().optional(),
    valueJson: tv.object(),
});
export type PartialCondition = SchemaType<typeof PartialConditionSchema>;

export class Condition<TValue extends any = any> {
    id?: number;
    valueJson: TValue;
    questionnaire?: Questionnaire;

    question?: Question;

    constructor() {
        this.valueJson = {} as TValue;
    }

    static compare(a: string, b: string) {
        if (!(typeof a === "string") || !(typeof b === "string")) {
            console.warn("comparing non-string", a, b);
            return false;
        }
        return (
            a.trim().localeCompare(b.trim(), ["nl", "fr", "en"], {
                ignorePunctuation: true,
                sensitivity: "base",
            }) === 0
        );
    }

    static check(condition: Condition, type: QuestionType, answer: any): [boolean, string] {
        return checkers[type](answer, condition.valueJson);
    }

    static checkAllQuestionAnswers(questions: Question[]): boolean {
        return questions.every((question) => {
            if (question.answers!.length === 0) return true;
            let answer = question.answers![0].valueJson;
            return question.conditions!.every((condition) => Condition.check(condition, question.type, answer)[0]);
        });
    }
}

export interface MultipleConditionValue {
    orOptions: string[];
}

export type NumberConditionValue =
    | {
          operator: "min";
          min: number;
      }
    | {
          operator: "max";
          max: number;
      };

export interface OpenConditionValue {
    contains: string;
}

export interface MultipleTableConditionValue {}
